import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-triangle-down-arrow",
  "use": "icon-triangle-down-arrow-usage",
  "viewBox": "0 0 1877 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1877 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-triangle-down-arrow\"><defs><style></style></defs><path d=\"M782.432 977.92L54.197 295.253C-58.613 189.44 16.138 0 170.933 0h1456.299c154.794 0 229.717 189.44 116.736 295.253L1015.904 977.92a170.667 170.667 0 01-233.472 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol